import React, { useMemo } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import SkeletonPlaceholder from 'react-native-skeleton-placeholder';
import { useTheme } from '../../theme';
import { s, v } from '../../utils/libs';

type ProductPickerSkeletonProps = {
  rows?: number;
};

const ProductPickerSkeleton: React.FC<ProductPickerSkeletonProps> = ({
  rows = 12,
}) => {
  const { theme } = useTheme();
  const styles = useMemo(() => createStyles(theme), [theme]);
  const items = Array.from({ length: Math.max(3, rows) });

  return (
    <SkeletonPlaceholder
      backgroundColor={theme.colors.border}
      highlightColor={theme.colors.surfaceSecondary}>
      <View style={styles.container}>
        {items.map((_, idx) => (
          <View key={String(idx)} style={styles.row}>
            <SkeletonPlaceholder.Item
              width={`${idx % 3 === 0 ? 74 : idx % 3 === 1 ? 62 : 70}%`}
              height={v(14)}
              borderRadius={s(6)}
            />
          </View>
        ))}
      </View>
    </SkeletonPlaceholder>
  );
};

const createStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      flex: 1,
      paddingBottom: v(24),
      backgroundColor: theme.colors.surface,
    },
    row: {
      paddingVertical: v(10),
      paddingHorizontal: Platform.OS === 'web' ? 0 : s(14),
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.colors.border,
      backgroundColor: theme.colors.surface,
      justifyContent: 'center',
    },
  });

export default ProductPickerSkeleton;
